import { gql, useQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';

export interface GetClusterHealthSummaryVars {
    domainIdentifier: String;
    domainIdentuple: String
}

const GET_CLUSTER_HEALTH_SUMMARY = gql`
    query GetClusterHealthSummary(
            $domainIdentifier: String
            $domainIdentuple: String
            $piezoArtifacts: JSON
        ){
        clusterHealth: clusterHealth(
            domainIdentifier: $domainIdentifier
            piezoArtifacts: $piezoArtifacts
        )
        nodes: numberOfNodes(
            domainIdentifier: $domainIdentifier
            piezoArtifacts: $piezoArtifacts
        )
        clusterStats: clusterStats(
            domainIdentifier: $domainIdentifier
            piezoArtifacts: $piezoArtifacts
        )
        workloadClassification: getInsightsMetadata(
            domainIdentuple: $domainIdentuple
            resourceType: "DomainIdent"
            usecases: ["Classification"]
        )
    }
`;

export const useClusterHealthSummaryQuery = (vars: GetClusterHealthSummaryVars) => {
    return useQuery<AnyObject, GetClusterHealthSummaryVars>(GET_CLUSTER_HEALTH_SUMMARY, {
        variables: { ...vars },
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
    });
};